import Vue from "vue";
import trace from "./trace.mjs";
import { attributeString } from "./helpers/dom.mjs";

const componentDefinition = {
    data : {
        prefs : {}
    },
    methods : {
        getInputValue : function( input )
        {
            if( ! input )
                return undefined;

            switch( attributeString(input,'type') ) {
                case 'checkbox':
                    return input.checked;
            }
        },
        getFieldInput : function( field )
        {
            return field.getElementsByTagName('input')[0];
        },
        getStateHintFields : function()
        {
            return this.$el.querySelectorAll('[data-state-hints]');
        },
        getStateHintValue : function( value )
        {
            if( typeof value.toString !== 'undefined' )
                return value.toString();

            return value;
        },
        onValueChange : function( event ) {
            let key   = attributeString( event.target, 'name' );
            let value = this.getInputValue( event.target );
            trace.info('Preferences: updating', key, value);

            this.updateStateHints();
        },
        updateStateHintField : function( field )
        {
            let input = this.getFieldInput( field );
            let value = this.getStateHintValue( this.getInputValue(input) );

            field
                .querySelectorAll('.state-hints .state-hint')
                .forEach( hint => {
                    let hint_value = attributeString( hint, 'data-value' );
                    hint.classList.toggle( 'active', value === hint_value );
                })
            ;
        },
        updateStateHints : function()
        {
            this
                .getStateHintFields()
                .forEach( field => this.updateStateHintField(field) )
            ;
        }
    },
    mounted : function() {
        this.updateStateHints();
    }
};

const target_id = 'customer-preferences-form';
const element   = document.getElementById(target_id);

const form = element ? new Vue({
    ...componentDefinition,
    el: element
}) : null ;
